/* RequireCapability — JSX boundary that renders children only when the user has
   the required capability. Falls back to null, a DeniedState, or a custom fallback.

   Usage:
     <RequireCapability cap="org.members.invite">
       <InviteButton />
     </RequireCapability>

     <RequireCapability cap="org.audit.view" denied={<DeniedState reason="insufficient_permission" />}>
       <AuditPanel />
     </RequireCapability>

   cap  — single capability string; OR
   caps — array of capability strings (all required); OR
   any  — array of capability strings (any required)
*/
import React from 'react';
import { usePermissions } from './usePermissions.js';

export function RequireCapability({ cap, caps, any, denied = null, children }) {
  const perm = usePermissions();

  let granted;
  if (any) {
    granted = perm.hasAny(Array.isArray(any) ? any : [any]);
  } else if (caps) {
    granted = perm.hasAll(Array.isArray(caps) ? caps : [caps]);
  } else if (cap) {
    granted = perm.has(cap);
  } else {
    granted = true;
  }

  if (granted) return children;
  return denied;
}

/* WsRequireCapability — workspace-scoped variant. Needs wsPerm from useWsPermissions(). */
export function WsRequireCapability({ wsPerm, cap, denied = null, children }) {
  const granted = wsPerm ? wsPerm.has(cap) : false;
  if (granted) return children;
  return denied;
}
